import { ObservableMap } from 'mobx';
import { EditorServiceModels } from '@editor/client-rest-api';

export default function serializeOverriddenOptions(
    overriddenOptions: ObservableMap<string, EditorServiceModels.CritiqueTypeOption>,
    overriddenCategories: ObservableMap<string, boolean>
): string {
    return JSON.stringify({
        options: [...overriddenOptions.values()],
        categories: overriddenCategories,
    });
}
